import React from 'react'
import PropTypes from 'prop-types'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Controller } from 'react-hook-form'
import {
  FormControl,
  FormHelperText,
  FormLabel,
  // InputAdornment,
  // OutlinedInput,
  // TextField,
} from '@mui/material'
import { inputSizes, inputTypes } from '../../constants/input'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import dayjs from 'dayjs'

const InputDate = ({
  name,
  type,
  control,
  errors,
  size,
  placeholder,
  startIcon,
  endIcon,
  label,
  defaultValue,
  sx,
  sxFC,
  sxFL,
}) => {
  const seventeenYearsAgo = dayjs().subtract(17, 'year')
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <FormControl
          fullWidth
          sx={{
            mb: 1,
            ...sxFC,
          }}
        >
          <FormLabel
            htmlFor={name}
            sx={{
              ...sxFL,
            }}
          >
            {label}
          </FormLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format="YYYY-MM-DD"
              onChange={(value) => {
                field.onChange(value.format('YYYY-MM-DD'))
              }}
              maxDate={seventeenYearsAgo}
            />
          </LocalizationProvider>
          {!!errors[name] && (
            <FormHelperText error={!!errors[name]}>
              {errors[name] && errors[name].message}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  )
}

InputDate.defaultProps = {
  size: 'large',
  label: 'Input Label',
  placeholder: 'Input something...',
  defaultValue: '',
}

InputDate.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.any.isRequired,
  errors: PropTypes.any.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(inputSizes),
  type: PropTypes.oneOf(inputTypes),
  placeholder: PropTypes.string,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
}

export default InputDate
